module.exports = require("core-js/modules/esnext.map.reduce.js");